export default __webpack_public_path__ + "static/SCS Global Services Contour without Percentages-b27849a82e43cd0835f7b74f3277ef29.png";